module.exports = __webpack_public_path__ + "static/movie.35bc0af1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/movie.jpg
// module id = 1504
// module chunks = 19843951674672